import React from 'react';
import useStandardListCachingLogic from 'hook/useStandardListCachingLogic';
import { defaultBeneficiariesListQueryParams } from 'store/beneficiaries/reducer';
import { Beneficiary } from 'models/domain/benefciaries';
import StandardDataTable from 'components/common/organisms/StandardDataList';

import { BeneficiariesListProps } from './BeneficiariesList.types';
import { createBeneficiariesListColumns } from './tableColumns';
import { createBeneficiariesListConfiguration } from './BeneficiariesList.helpers';


function BeneficiariesList({
    // own props
    isInReadOnlyMode = false,
    companyId,
    businessUserId,
    // XXX  list state data
    listData,
    enhancedCurrentLocation,

    // other mapped props
    accessControl,
    dispatchFetchBeneficiariesList,
    dispatchClearBeneficiariesList,
    dispatchSetQueryParams,
    dispatchRequestNavigation,
    t,
}: BeneficiariesListProps): JSX.Element {
    // 1. context-specific / ownProps-driven list configuration
    const contextEnforcedQueryParams = {
        companyId,
        businessUserId,
    };

    // 2. standard BE endpoint -> queryParams & listFetching are in sync.
    const fetchData = (newQueryParams) => {
        if (enhancedCurrentLocation?.pathname) {
            const prams = {
                ...listData?.queryParams,
                ...newQueryParams,
            };

            dispatchSetQueryParams({ queryParams: prams, locationPathname: enhancedCurrentLocation.pathname });
            dispatchFetchBeneficiariesList({ queryParams: prams, locationPathname: enhancedCurrentLocation.pathname });
        }
    };

    // 3. standardListCachingLogic
    const isListInitialStateDefined = useStandardListCachingLogic<Beneficiary>({
        contextEnforcedQueryParams,
        defaultItemsListQueryParams: defaultBeneficiariesListQueryParams,

        enhancedCurrentLocation,
        listData,

        dispatchFetchItemsList: dispatchFetchBeneficiariesList,
        dispatchClearItemsList: dispatchClearBeneficiariesList,
        dispatchSetQueryParams,
    });


    // 4. context & permission dependent optional account list filters & buttons

    // 5. standard render component
    return (
        <StandardDataTable<Beneficiary>
            t={t}
            fetchData={fetchData}
            totalCount={listData.totalCount}
            items={listData.items}
            isLoadingData={listData.isLoadingList}
            queryParams={listData.queryParams}
            isListInitialStateDefined={isListInitialStateDefined}
            columnsConfiguration={createBeneficiariesListColumns({
                t,
                accessControl,
                queryParams: listData.queryParams,
            })}
            filtersConfiguration={createBeneficiariesListConfiguration({ t })}

        />
    );
}

export default BeneficiariesList;

